import { FileCheck2, Gem, Wrench } from "lucide-react";
import { IMAGES } from "@/lib/content";

const PILLARS = [
  { icon: FileCheck2, title: "Pratiche incluse", desc: "Gestiamo noi allaccio, pratiche GSE e documentazione per le detrazioni." },
  { icon: Gem, title: "Estetica curata", desc: "Moduli full black e posa pulita, pensati per integrarsi con l'architettura." },
  { icon: Wrench, title: "Team interno", desc: "Progettazione e installazione seguite dai nostri tecnici, dal primo sopralluogo al collaudo." },
];

export const About = () => (
  <section id="chi-siamo" className="bg-slate-50 py-20 lg:py-28">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:px-8">
      <div className="lg:col-span-5">
        <img src={IMAGES.about} alt="Facciata con pannelli solari" className="aspect-[4/5] w-full rounded-3xl object-cover" />
      </div>
      <div className="flex flex-col justify-center lg:col-span-6 lg:col-start-7">
        <span className="eyebrow w-fit">Chi Siamo</span>
        <h2 className="section-title mt-5">Il fotovoltaico, fatto con precisione.</h2>
        <p className="mt-6 text-base leading-relaxed text-slate-600 sm:text-lg">
          Apollo Solar è un marchio registrato del Gruppo Pixa Web sagl è una società Svizzera nel Canton Ticino, con sede anche a Milano Italia,  specializzata nella progettazione e installazione di impianti fotovoltaici per case, attività commerciali e aziende. Seguiamo ogni fase con un unico referente, per un impianto che rende davvero.
        </p>
        <div className="mt-10 grid gap-6 sm:grid-cols-3">
          {PILLARS.map((p) => (
            <div key={p.title} data-testid={`about-pillar-${p.title.toLowerCase().replace(/\s/g, "-")}`}>
              <p.icon className="h-6 w-6 text-emerald-600" />
              <h3 className="mt-3 text-base font-semibold text-slate-900">{p.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
